module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"invitePeople":"Invite people","copyAndShare":"Copy and share the link to your Freatle list. Every person who has this link will be able to add items; no account required.","copy":"Copy","linkCopied":"The event link has been copied successfully."},"fr_FR":{"invitePeople":"Inviter des participants","copyAndShare":"Copiez et partagez le lien vers votre liste Freatle. Toute personne disposant du lien pourra ajouter des items ; pas de compte requis.","copy":"Copier","linkCopied":"Le lien de l\u0027événement a bien été copié."}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/components/event-invite-link.json
// module id = 202
// module chunks = 1